import React from 'react';
import './styles.css';
import { hidePartOfEmail } from '../../utils/str';

type TokenFeedbackProps = {
    isTokenValid: boolean;
    userEmail: string;
    tokenExpirationTime?: string; 
    timeRemaining?: string;
    isResent?: boolean;
};

const TokenFeedback: React.FC<TokenFeedbackProps> = ({
    isTokenValid,
    userEmail,
    tokenExpirationTime,
    timeRemaining,
    isResent = false
}) => {
    
    const maskedEmail = hidePartOfEmail(userEmail);
    
    let adjustedExpirationTime: string | undefined = undefined;
    /** Só interpreta como relógio (evita NaN com textos ou ISO em tokenExpirationTime). */
    const timeTokenRe = /^\d{1,2}:\d{2}(:\d{2})?$/;
    if (tokenExpirationTime && timeTokenRe.test(tokenExpirationTime.trim())) {
        const [hours, minutes, seconds] = tokenExpirationTime.split(':').map(Number);
        if (Number.isFinite(hours) && Number.isFinite(minutes)) {
            const date = new Date();
            date.setHours(hours, minutes || 0, Number.isFinite(seconds as number) ? (seconds as number) : 0);
            date.setHours(date.getHours() - 1);
            if (!isNaN(date.getTime())) {
                const formattedHours = date.getHours();
                const formattedMinutes = date.getMinutes().toString().padStart(2, '0');
                adjustedExpirationTime = `${formattedHours}h ${formattedMinutes}min`;
            }
        }
    }

    if (isTokenValid) {
        return (
            <div className="token-feedback valid-token">
                <p className="first-line">
                    {isResent 
                        ? `Um e-mail com seu token atual foi enviado para ${maskedEmail}.`
                        : `Você possui token válido neste momento. Use o token atual enviado anteriormente para o seu e-mail ${maskedEmail}.`
                    }
                </p>
                {timeRemaining && (
                    <p className="second-line">
                        Seu token tem validade de {timeRemaining}.
                    </p>
                )}
            </div>
        );
    }

    return (
        <div className="token-feedback invalid-token">
            {adjustedExpirationTime ? (
                <p className="first-line">
                    Seu token expirou às {adjustedExpirationTime}.
                </p>
            ) : (
                <p className="first-line">
                    Seu token expirou.
                </p>
            )}
            <p className="second-line">
                Um novo token válido foi enviado para o seu e-mail {maskedEmail}.
            </p>
        </div>
    );
};

export default TokenFeedback;